import { Building } from "../../building/building.model";
import { Company } from "../../company/company.model";

export class GuestReportRequest {
  type?: string;
  dateFrom?: string;
  dateTo?: string;
  idBuilding?: number;
  idCompany?: number;
}

export class RequestParameters {
  type?: string;
  dateFrom?: string;
  dateTo?: string;
  building?: Building;
  company?: Company;
}